import {
  combineCapabilities,
  ProductCapability,
  type BillingConfig,
  type OfferingMarketingContent,
  type ProductManifest,
} from "@constructorfleet/offerings-sdk";
import { BHG_OFFERING_ID } from "./constants";

export type BhgCallCatalog = {
  id: string;
  name: string;
  marketing: OfferingMarketingContent;
  billing: BillingConfig;
  manifest: ProductManifest;
};

export const bhgCallCatalog: BhgCallCatalog = {
  id: BHG_OFFERING_ID,
  name: "BHG Check-in Assist",
  marketing: {
    summary: "Makes your daily clinic check-in calls and keeps a record every time.",
    description:
      "Your clinic calls, handled automatically — with a clear record you can access anytime.",
    primaryCtaLabel: "Get started",
    tagline: "Never miss your daily BHG medication check-in again.",
    highlights: [
      "Automated daily calls to the BHG medication line",
      "Your result delivered by text at a time you choose",
      "Timestamped transcripts and audio you can download",
      "Notified before and after every call",
    ],
  },
  billing: {
    billingModel: "flat",
    priceDimensions: ["monthly"],
    pricing: {
      price: 1500,
      billingModel: "flat",
      interval: "month",
      priceDimensions: ["monthly"],
    },
  },
  manifest: {
    version: "1.0.0",
    capabilities: combineCapabilities(
      ProductCapability.Dashboard,
      ProductCapability.AdminSettings,
      ProductCapability.BackgroundJob,
      ProductCapability.Routes,
      ProductCapability.Billing
    ),
    billingModel: "flat",
    pricing: {
      price: 1500,
      billingModel: "flat",
      interval: "month",
      priceDimensions: ["monthly"],
    },
  },
};

export default bhgCallCatalog;
